import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse';

/**
 * no description
 */
export class ListGcpSharedSubnetsApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Gets shared subnets from other GCP projects that are usable in this project
   * @param accountId ID of the restore gcp project
   * @param region The region to get shared subnets for
   * @param projectId The project ID
   * @param network Optional network name to filter subnets
   */
  public async listGcpSharedSubnets(accountId: string, region: string, projectId: string, network?: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'accountId' is not null or undefined
    if (accountId === null || accountId === undefined) {
      throw new RequiredError("ListGcpSharedSubnetsApi", "listGcpSharedSubnets", "accountId");
    }


    // verify required parameter 'region' is not null or undefined
    if (region === null || region === undefined) {
      throw new RequiredError("ListGcpSharedSubnetsApi", "listGcpSharedSubnets", "region");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListGcpSharedSubnetsApi", "listGcpSharedSubnets", "projectId");
    }



    // Path Params
    const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/regions/{region}/gcp-shared-subnets'
      .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
      .replace('{' + 'region' + '}', encodeURIComponent(String(region)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (network !== undefined) {
      requestContext.setQueryParam("network", ObjectSerializer.serialize(network, "string", "noformat-itsfineandsafe"));
    }


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListGcpSharedSubnetsApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listGcpSharedSubnets
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listGcpSharedSubnetsWithHttpInfo(response: ResponseContext): Promise<HttpInfo<ListGcpSubnetsResponse >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: ListGcpSubnetsResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "ListGcpSubnetsResponse", ""
      ) as ListGcpSubnetsResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Not found", undefined, response.headers, response);
    }
    if (isCodeInRange("500", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Internal server error", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: ListGcpSubnetsResponse = await response.body.json() as ListGcpSubnetsResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
